
    import React from 'react'
    import Base from '@ucheba/ui/components/Icon'
    import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js"
    import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js"

    const symbol = new SpriteSymbol({
  "id": "icon__youtube-filled",
  "use": "icon__youtube-filled-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon__youtube-filled\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path fill=\"currentColor\" d=\"M8 2c-2.04 0-3.844.23-4.941.41-.899.144-1.614.911-1.778 1.895C1.141 5.166 1 6.423 1 8s.14 2.834.281 3.695c.164.984.88 1.747 1.778 1.896C4.16 13.77 5.973 14 8 14c2.027 0 3.836-.23 4.938-.41.902-.144 1.617-.911 1.78-1.895C14.86 10.83 15 9.572 15 8c0-1.577-.14-2.834-.285-3.695-.16-.984-.875-1.751-1.774-1.896A31.407 31.407 0 0 0 8 2zM6 5.273v5.454L11 8 6 5.273z\" /></g></symbol>"
})
    sprite.add(symbol)

    export default React.memo(function IconYoutubeFilledIcon(props) {
      const { className, ...restProps } = props
      return <Base.Icon className={className} id="icon__youtube-filled" {...restProps} />
    })
  